<div class="adx-video-display-container" [class.layout-pip]="layout === 'pip'" [class.layout-fullscreen]="layout === 'fullscreen'" [class.layout-expanded]="layout === 'expanded'">

  <!-- Remote Video (Main Display) -->
  <div class="adx-remote-video-container" (touchstart)="focusDtmfInput()">
    <video
      #remoteVideo
      class="adx-remote-video"
      autoplay
      playsinline
      [muted]="false"
      [attr.aria-label]="'Remote video stream from ' + (call?.name || call?.number || 'caller')">
    </video>

    <!-- Call Timer (Top Center - Fullscreen Only) -->
    <div class="adx-call-timer-overlay" *ngIf="layout === 'fullscreen'">
      <span class="adx-timer-text">{{ callDuration }}</span>
    </div>

    <!-- Connection Quality Indicator (Upper Left Corner) -->
    <div class="adx-connection-indicator-remote"
         *ngIf="showConnectionIndicator && !isRemoteVideoLoading"
         [class]="getConnectionQualityClass()"
         [matTooltip]="getConnectionQualityTooltip()"
         #statsTooltip="matTooltip"
         matTooltipClass="video-stats-tooltip"
         matTooltipTouchGestures="off"
         (mouseenter)="startStatsSubscription()"
         (mouseleave)="stopStatsSubscription()"
         (touchstart)="toggleStatsTooltip($event)">
      <div class="adx-quality-dot"></div>
    </div>

    <!-- Loading Indicator -->
    <div class="adx-video-loading" *ngIf="isRemoteVideoLoading">
      <div class="adx-loading-spinner"></div>
      <span class="adx-loading-text">{{ 'ASTIMAX.PHONE.WIDGET.VIDEO.STATUS.CONNECTING' | translate }}</span>
    </div>

    <!-- DTMF Key Visual Feedback -->
    <div class="adx-dtmf-overlay" *ngIf="showDtmfOverlay" (animationend)="onDtmfAnimationEnd()">
      <span class="adx-dtmf-key">{{ dtmfDisplayKey }}</span>
    </div>

    <!-- Video Paused Overlay -->
    <div class="adx-video-paused-overlay" *ngIf="!isRemoteVideoLoading && isRemoteVideoPaused">
      <fa-icon [icon]="['fas', 'video-slash']" class="adx-paused-icon"></fa-icon>
      <span class="adx-paused-text">{{ 'ASTIMAX.PHONE.WIDGET.VIDEO.VIDEO_PAUSED' | translate }}</span>
    </div>

    <!-- Caller Info Overlay (Centered at Bottom) -->
    <div class="adx-caller-info-overlay"
         [class.controls-visible]="controlsVisible">
      <span class="caller-name">
        <ng-container *ngIf="call?.name && call?.number">{{ call!.name }} ({{ call!.number }})</ng-container>
        <ng-container *ngIf="call?.name && !call?.number">{{ call!.name }}</ng-container>
        <ng-container *ngIf="!call?.name && call?.number">{{ call!.number }}</ng-container>
        <ng-container *ngIf="!call?.name && !call?.number">{{ 'ASTIMAX.PHONE.WIDGET.CALL.UNKNOWN' | translate }}</ng-container>
      </span>
    </div>
  </div>

  <!-- Local Video (PiP Overlay - Shows/Hides with Controls or When Pinned) -->
  <div class="adx-local-video-container"
       [class.hidden]="!isLocalVideoVisible"
       [class.pinned]="isLocalVideoPinned">
    <video
      #localVideo
      class="adx-local-video"
      autoplay
      playsinline
      [muted]="true"
      [attr.aria-label]="'ASTIMAX.PHONE.WIDGET.VIDEO.STATUS.LOCAL_VIDEO_OFF' | translate">
    </video>

    <!-- Local Video Paused Indicator -->
    <div class="adx-local-video-paused" *ngIf="isLocalVideoPaused">
      <fa-icon [icon]="['fas', 'video-slash']"></fa-icon>
    </div>

    <!-- Pin/Unpin Button (Shows on Hover) -->
    <button
      mat-icon-button
      class="adx-pin-button"
      (click)="toggleLocalVideoPin()"
      [matTooltip]="isLocalVideoPinned ? ('ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.UNPIN_VIDEO' | translate) : ('ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.PIN_VIDEO' | translate)"
      [attr.aria-label]="isLocalVideoPinned ? ('ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.UNPIN_VIDEO' | translate) : ('ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.PIN_VIDEO' | translate)">
      <fa-icon [icon]="isLocalVideoPinned ? ['fas', 'thumbtack'] : ['fas', 'thumbtack']" [class.pinned-icon]="isLocalVideoPinned"></fa-icon>
    </button>
  </div>

  <!-- Receive-Only Mode Indicator (shown when not sending local video) -->
  <div class="adx-receive-only-indicator" *ngIf="isReceiveOnlyMode">
    <fa-icon [icon]="['fas', 'video-slash']"></fa-icon>
    <span class="adx-indicator-text">{{ 'ASTIMAX.PHONE.WIDGET.VIDEO.RECEIVE_ONLY' | translate }}</span>
  </div>

  <!-- TODO: Undock feature not yet implemented
  <div class="adx-quick-actions" *ngIf="showControls && layout === 'pip'">
    <button
      mat-icon-button
      class="adx-action-button"
      (click)="requestUndock()"
      [matTooltip]="'ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.UNDOCK_VIDEO' | translate"
      [attr.aria-label]="'ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.UNDOCK_VIDEO' | translate">
      <fa-icon [icon]="['fas', 'external-link-alt']"></fa-icon>
    </button>
  </div>
  -->

  <!-- Hidden input for mobile virtual keyboard DTMF -->
  <input
    #dtmfHiddenInput
    class="adx-dtmf-hidden-input"
    type="tel"
    inputmode="tel"
    autocomplete="off"
    (input)="onHiddenDtmfInput($event)"
    aria-hidden="true"
    tabindex="-1">

  <!-- Fullscreen Exit Button (always shown in fullscreen since widget header is hidden) -->
  <div class="adx-fullscreen-exit" *ngIf="layout === 'fullscreen'">
    <button
      mat-icon-button
      class="adx-exit-button"
      (click)="toggleFullscreen()"
      [matTooltip]="'ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.EXIT_FULLSCREEN' | translate"
      [attr.aria-label]="'ASTIMAX.PHONE.WIDGET.VIDEO.CONTROLS.EXIT_FULLSCREEN' | translate">
      <fa-icon [icon]="['fas', 'compress']"></fa-icon>
    </button>
  </div>
</div>
